import script from "./PaymentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentModal.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentModal.vue?vue&type=style&index=0&id=76dbeabc&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76dbeabc"]])

export default __exports__